import axios from "axios";
import { SERVER_URL } from "./../env";

export default {
  state: {
    isAuth: false,
    authErrors: {},
    user: {}
  },

  getters: {
    isAuth: state => state.isAuth,
    authErrors: state => state.authErrors,
    hasAuthErrors: state => Object.keys(state.authErrors).length > 0,
    user: state => state.user
  },

  mutations: {
    login: state => {
      state.isAuth = true;
    },
    logout: state => {
      state.isAuth = false;
      state.user = {};
    },
    setAuthErrors: (state, payload) => {
      state.authErrors = payload;
    },
    clearAuthErrors: state => {
      state.authErrors = {};
    },
    setUser: (state, payload) => {
      state.user = { ...state.user, ...payload };
    }
  },

  actions: {
    async login({ commit, dispatch }, { email, password }) {
      commit("clearAuthErrors");
      try {
        const res = await axios.post(`${SERVER_URL}/api/auth/login`, {
          e_mail: email,
          password
        });
        if (res.data.result === false) {
          commit("setErrors", {
            message: "Логин и/или пароль введен(ы) неверно"
          });
        } else {
          commit("clearAuthErrors");
          commit("login");
          commit("setUser", res.data.user);
        }
      } catch (e) {
        dispatch("setHttpError", e);
      }
    },

    async logout({ commit, dispatch }) {
      try {
        const res = await axios.get(`${SERVER_URL}/api/auth/logout`);
        if (res.data.result === true) commit("logout");
      } catch (e) {
        dispatch("setHttpError", e);
      }
    },

    async getUser({ commit, dispatch }) {
      try {
        const res = await axios.get(`${SERVER_URL}/api/auth/check`);

        if (res.data.result === true) {
          commit("setUser", res.data.user);
          commit("login");
        }
      } catch (e) {
        dispatch("setHttpError", e);
      }
    },

    async saveUser({ commit, dispatch }, payload) {
      try {
        const res = await axios.post(`${SERVER_URL}/api/profile/my`, payload);

        if (res.data.result === true) {
          commit("setUser", payload);
          commit("clearAuthErrors");
        } else commit("setAuthErrors", res.data.errors);
      } catch (e) {
        dispatch("setHttpError", e);
      }
    },

    async register(
      { commit, dispatch },
      { email, password, captcha, secret, name }
    ) {
      try {
        const res = await axios.post(`${SERVER_URL}/api/auth/register`, {
          e_mail: email,
          password,
          name,
          captcha,
          captcha_secret: secret
        });

        if (res.data.result === false) {
          commit("setAuthErrors", res.data.errors);
        } else commit("clearAuthErrors");
      } catch (e) {
        dispatch("setHttpError", e);
      }
    },

    async restorePassword({ commit, dispatch }, { email }) {
      try {
        const res = await axios.post(`${SERVER_URL}/api/auth/restore`, {
          email
        });

        if (res.data.result === false) {
          commit("setAuthErrors", {
            restoreError: "Логин не найден"
          });
        } else commit("clearAuthErrors");
      } catch (e) {
        dispatch("setHttpError", e);
      }
    },

    async changePassword(
      { commit, dispatch },
      { code, password, captcha, secret }
    ) {
      try {
        const res = await axios.post(`${SERVER_URL}/api/auth/password`, {
          code,
          password,
          captcha,
          captcha_secret: secret
        });

        if (res.data.result === false) {
          commit("setAuthErrors", res.data.errors);
        } else commit("clearAuthErrors");
      } catch (e) {
        dispatch("setHttpError", e);
      }
    }
  }
};
